import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from "react-router-dom";
import { erroToastify } from '../../../shared/validacaoToastify';
import { CamposPadroes } from '../../../shared/CamposPadroes';
import { ToastContainer } from "react-toastify";
import { getTodosModelos } from '../../../services/apiModelo';
import { getTodasCondicoes } from '../../../services/apiCondicao';
import { getCategorias, getTodasCategorias } from '../../../services/apiCategoria';
import { getTodasCidades } from '../../../services/apiCidade';
import { postAnuncio } from '../../../services/apiAnuncio';
import { postImagem, putImagemCapa } from '../../../services/apiImagem';
import imagemPadrao from '../../../components/layout/rodape/M.svg'
import ModalVisualizacaoImg from '../../../components/modal/modalVisualizacaoImg/modalVisualizacaoImg';
import buscarDados from '../../../shared/buscarDados';
import "react-toastify/dist/ReactToastify.css";
import './incluirAnuncio.css';
import PrimeiroFormulario from '../../../components/formularioAnuncio/primeiroFormulario';
import SegundoFormulario from '../../../components/formularioAnuncio/segundoFormulario';
import TerceiroFormulario from '../../../components/formularioAnuncio/terceiroFomulario';
import QuartoFormulario from '../../../components/formularioAnuncio/quartoFormulario';
import { Spinner } from 'react-bootstrap';

function IncluirAnuncio() {
    const [formValues, setFormValues] = useState({
        nmAnuncio: '',
        cdCategoria: '',
        cdModelo: '',
        cdCondicao: '',
        cdUsuario: '1',
        dtPublicacao: new Date().toLocaleDateString('en-CA'),
        vlAnuncio: '',
        cdCidade: '',
        dmTipoAnuncio: true,
        dmAtivo: true,
        nrAnunciada: '',
        dsAnuncio: ''
    });

    const [categorias, setCategorias] = useState<{ cdCategoria: number; nmCategoria: string; }[]>([]);
    const [modelos, setModelos] = useState<{ cdModelo: number; nmModelo: string; }[]>([]);
    const [cidades, setCidades] = useState<{ cdCidade: number; nmCidade: string; }[]>([]);
    const [condicoes, setCondicoes] = useState<{ cdCondicao: number; nmCondicao: string; }[]>([]);
    const [validacaoAtiva, setValidacaoAtiva] = useState<any>(false);
    const [imagens, setImagens] = useState<File[]>([]);
    const [modalIsOpen, setModalIsOpen] = useState(false);
    const [selectedImageIndex, setSelectedImageIndex] = useState(0);
    const [numeroImagensSelecionadas, setNumeroImagensSelecionadas] = useState(0);
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const cdUsuario = localStorage.getItem('cdUsuario');

    const handleFieldChange = (name: string, value: string | number | boolean) => {
        setFormValues((prevFormValues) => ({
            ...prevFormValues,
            [name]: value
        }));
        setValidacaoAtiva(false);
    };

    const handleInputChange = (value: string, field: string) => {
        setFormValues({ ...formValues, [field]: value });
    };

    const handleImageChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const files = e.target.files;
        if (files) {
            const imagesArray = Array.from(files);
            setImagens((prevImages) => {
                const newImagesArray = [...prevImages, ...imagesArray].slice(0, 5);
                setNumeroImagensSelecionadas(newImagesArray.length);
                return newImagesArray;
            });
            e.target.value = '';
            setValidacaoAtiva(false)
        }
    };

    const handleRemoveImage = (index: number) => {
        const updatedImages = [...imagens];
        updatedImages.splice(index, 1);
        setImagens(updatedImages);
        setNumeroImagensSelecionadas(prevNumero => prevNumero - 1);
    };

    const openModal = (index: number) => {
        setSelectedImageIndex(index);
        setModalIsOpen(true);
    };

    const closeModal = () => {
        setModalIsOpen(false);
    };

    const handleImageClick = (index: number) => {
        if (imagens[index]) {
            openModal(index);
        }
    };

    useEffect(() => {
        const fetchData = async () => {
            try {
                const responseModelos = await getTodosModelos();
                setModelos(responseModelos);

                const responseCidades = await getTodasCidades();
                setCidades(responseCidades);

                const responseCondicoes = await getTodasCondicoes();
                setCondicoes(responseCondicoes);

                const responseCategoria = await getTodasCategorias();
                setCategorias(responseCategoria);
            } catch (error) {
                console.error("Erro ao buscar dados:", error);
            }
        };
        fetchData();
    }, []);

    const enviarImagens = async (cdAnuncio: number, cdUsuarioInc: number, cdUsuarioAlt: number) => {
        try {
            for (let i = 0; i < imagens.length; i++) {
                const formData = new FormData();
                formData.append("file", imagens[i]);
                const resposta = await postImagem(cdAnuncio, cdUsuarioAlt, cdUsuarioInc, formData);

                const dados: any = {
                    cdImagem: resposta.data.cdImagem,
                    dmCapa: i === 0
                };

                if (i === 0) {
                    await putImagemCapa(dados)
                } else {
                    dados.dmCapa = false;
                    await putImagemCapa(dados)
                }
            }
        } catch (error: any) {
            if (error.response.data) {
                erroToastify(error.response.data);
            }
        }
    };

    const handleConfirmar = async (event: React.FormEvent<HTMLFormElement>,) => {
        event.preventDefault();
        setLoading(true);
        try {
            if (imagens.length > 0) {
                const imagensSaoValidas = imagens.every(file => {
                    return file.type.startsWith('image/') && !file.type.toLowerCase().includes('svg');
                });
                if (!imagensSaoValidas) {
                    throw new Error('Por favor, selecione apenas arquivos de imagem');
                }
            }

            const dataPresente = new Date();
            const dataPublicacaoInput = formValues.dtPublicacao;

            const horaAtual = dataPresente.toTimeString().split(' ')[0];
            const dataPublicacao = `${dataPublicacaoInput}T${horaAtual}`;
            const dataAlteracao = `${new Date().toLocaleDateString('en-CA')}T${horaAtual}`;

            let envioDeDados: any = {
                nmAnuncio: formValues.nmAnuncio === '' ? '' : formValues.nmAnuncio,
                cdUsuario: formValues.cdUsuario === '' ? '' : cdUsuario,
                dtPublicacao: dataPublicacao,
                vlAnuncio: formValues.vlAnuncio === '' ? null : formValues.vlAnuncio,
                cdCidade: formValues.cdCidade === '' ? null : formValues.cdCidade,
                dmTipoAnuncio: formValues.dmTipoAnuncio,
                dmAtivo: formValues.dmAtivo,
                dsAnuncio: formValues.dsAnuncio === '' ? '' : formValues.dsAnuncio,
                ...CamposPadroes.toObjeto(Number(cdUsuario), 0, dataAlteracao, dataAlteracao, true)
            };

            if (new Date(dataPublicacao) > dataPresente) {
                envioDeDados.dmAtivo = false;
            }

            if (formValues.dmTipoAnuncio) {
                envioDeDados = {
                    ...envioDeDados,
                    cdCategoria: formValues.cdCategoria === '' ? null : formValues.cdCategoria,
                    cdModelo: formValues.cdModelo === '' ? 0 : formValues.cdModelo,
                    cdCondicao: formValues.cdCondicao === '' ? 0 : formValues.cdCondicao,
                    nrAnunciada: formValues.nrAnunciada === '' ? 0 : formValues.nrAnunciada,
                };
            }

            const response = await postAnuncio(envioDeDados);
            const CdAnuncio = response.data.cdAnuncio;
            await enviarImagens(CdAnuncio, envioDeDados.cdUsuario, envioDeDados.cdUsuario);
            const successMessage = "O Anúncio foi incluído com sucesso!";
            navigate(`/milshop/usuario/meus-anuncios?successMessage=${encodeURIComponent(successMessage)}`);
        } catch (error: any) {
            if (error.response?.data) {
                erroToastify(error.response.data);
                setValidacaoAtiva(true);
            } else {
                erroToastify(error.message);
                setValidacaoAtiva(true);
            }
        }
        finally {
            setLoading(false);
        }
    };

    const getImagemUrl = (index: number) => {
        if (imagens[index]) {
            return URL.createObjectURL(imagens[index]);
        } else {
            return '';
        }
    };

    return (
        <> {loading && (
            <div className="spinner-overlay">
                <Spinner animation="border" variant="dark" />
            </div>
        )}
            <form className="container containerAnuncio" onSubmit={handleConfirmar} encType="multipart/form-data">
                <PrimeiroFormulario
                    formValues={formValues}
                    handleFieldChange={handleFieldChange}
                />
                <div className="bloco01">
                    <SegundoFormulario
                        formValues={formValues}
                        handleFieldChange={handleFieldChange}
                        validacaoAtiva={validacaoAtiva}
                        cidades={cidades}
                    />
                    <TerceiroFormulario
                        formValues={formValues}
                        handleFieldChange={handleFieldChange}
                        validacaoAtiva={validacaoAtiva}
                        categorias={categorias}
                        modelos={modelos}
                        condicoes={condicoes}
                    />
                </div>
                <div className='bloco02 estiloGeral mt-3 shadow-sm p-3 bg-light rounded'>
                    <QuartoFormulario
                        formValues={formValues}
                        handleFieldChange={handleFieldChange}
                        validacaoAtiva={validacaoAtiva}
                        todasAsImagens={imagens}
                        setNumeroImagensSelecionadas={setNumeroImagensSelecionadas}
                        numeroImagensSelecionadas={numeroImagensSelecionadas}
                        imagemPadrao={imagemPadrao}
                        handleImageChange={handleImageChange}
                        handleRemoveImage={handleRemoveImage}
                        handleImageClick={handleImageClick}
                        setImagem={setImagens}
                    />
                </div>
                <div className="botoes mt-3">
                    <a className="btn btn-outline-danger me-2 btn-sm" href="/milshop/usuario/meus-anuncios" role="button" style={{ width: "100px" }}>Cancelar</a>
                    <button type="submit" className="btn btn-outline-primary btn-sm" style={{ width: "100px" }}>Incluir</button>
                </div>
            </form>
            <ModalVisualizacaoImg
                imagens={imagens}
                getImagemUrl={getImagemUrl}
                selectedImageIndex={selectedImageIndex}
                modalIsOpen={modalIsOpen}
                closeModal={closeModal}
            />
            <ToastContainer />
        </>
    );
}
export default IncluirAnuncio;
